"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var trip_1 = require("./trip");
exports.TripService = trip_1.TripService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/trips/services/index.ts
// module id = 564
// module chunks = 0